var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFalsePositiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(-559.525 -35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 83,
    height: 84,
    rx: 10,
    transform: "translate(559.525 35)",
    fill: "#ff2366",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(580.43 52.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M398.523,268.663a2.787,2.787,0,0,1-.8-2.108c.033-5.688.018-11.377.015-17.065,0-3.435-1.705-5.138-5.133-5.142-1.658,0-3.315,0-5.071,0a3.613,3.613,0,0,0-2.386-4.116H369.482a3.552,3.552,0,0,0-2.31,4.035c-.383.03-.69.076-1,.078-1.63.007-3.261-.019-4.89.013a4.317,4.317,0,0,0-4.277,3.961,13.973,13.973,0,0,0-.043,1.412q0,16.948,0,33.9c0,3.278.674,4.314,3.6,5.545h30.455a29.044,29.044,0,0,0,5.083-1.982A12.068,12.068,0,0,0,398.523,268.663Zm-27.218-24.3h12.064v3.963H371.305Zm8.982,40.622a7.106,7.106,0,0,1-.8.1c-5.8.007-11.6-.011-17.4.022-.857.007-1.107-.237-1.105-1.105q.043-17.287,0-34.574c0-.77.183-1.122,1.025-1.1,1.662.048,3.324.013,5.064.013.063.635.078,1.1.161,1.564a2.9,2.9,0,0,0,2.941,2.521q7.12.026,14.242,0a3.05,3.05,0,0,0,3.1-2.874c.035-.354.006-.716.006-1.205,1.88,0,3.683,0,5.484,0,.742,0,.62.551.62,1.009q.007,5.381,0,10.763V265.3c-6.4-1.521-11.608.1-14.832,5.965C376.2,276,377.046,280.625,380.287,284.987Zm9.364.1a8.073,8.073,0,0,1-8.227-8.147,8.168,8.168,0,0,1,8.116-8.186,8.272,8.272,0,0,1,8.212,8.136A8.154,8.154,0,0,1,389.652,285.087Z",
    transform: "translate(-356.963 -240.232)",
    fill: "#ff2366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M384.168,290.411l.318,0h.146c-.05,0-.1,0-.146,0C384.38,290.407,384.275,290.409,384.168,290.411Zm-1.347.009c.29.009.579.006.87,0C383.4,290.424,383.112,290.429,382.822,290.42Z",
    transform: "translate(-372.322 -270.033)",
    fill: "#ff2366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M391.266,302.537a1.953,1.953,0,0,1-2.13,2.071q-4.946.029-9.9,0a2,2,0,1,1-.02-3.986c1.669-.021,3.335-.006,5-.006,1.631,0,3.261-.013,4.892,0C390.47,300.638,391.239,301.342,391.266,302.537Z",
    transform: "translate(-368.903 -276.093)",
    fill: "#ff2366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M419.346,282.412c.013,1.271-.8,2.025-2.271,2.053-1.266.024-2.534,0-3.8,0s-2.534.017-3.8,0a2.051,2.051,0,1,1,.05-4.061q3.749-.023,7.5,0C418.465,280.414,419.33,281.183,419.346,282.412Z",
    transform: "translate(-386.777 -264.086)",
    fill: "#ff2366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M384.28,322.639a2.1,2.1,0,0,1-2.356,2c-1.268.013-2.536,0-3.8,0s-2.537.017-3.8,0a1.978,1.978,0,0,1-2.217-1.995,2.021,2.021,0,0,1,2.269-2.062q3.8-.026,7.605,0A2.083,2.083,0,0,1,384.28,322.639Z",
    transform: "translate(-365.955 -287.947)",
    fill: "#ff2366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M385.154,282.365a1.92,1.92,0,0,1-1.912,2.064c-.27.022-.54.028-.811.028q-.268,0-.535-.007l-.12,0c-.139,0-.276-.007-.415-.007-.048,0-.1,0-.144,0h-.146l-.318,0-.476.009c-.291.007-.581.009-.87,0-.133,0-.266-.011-.4-.022a1.988,1.988,0,0,1-1.936-2.064A1.962,1.962,0,0,1,379,280.4c1.407-.065,2.824-.063,4.233,0A1.934,1.934,0,0,1,385.154,282.365Z",
    transform: "translate(-368.907 -264.064)",
    fill: "#ff2366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M428.906,329.87c1.437,0,2.874,0,4.311,0a1.136,1.136,0,0,0,1.259-1.111,1.12,1.12,0,0,0-1.221-1.145q-4.383-.01-8.766,0a1.477,1.477,0,0,0-.6.129,1.126,1.126,0,0,0,.519,2.121C425.9,329.876,427.4,329.868,428.906,329.87Z",
    transform: "translate(-396.351 -292.128)",
    fill: "#ff2366"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalsePositiveIcon);
export default __webpack_public_path__ + "static/media/FalsePositiveIcon.24658f1d546099b56ba39b5b16c91d9f.svg";
export { ForwardRef as ReactComponent };